module.exports = __webpack_public_path__ + "static/media/logo_text_cn@2x.1d6586e0.png";